import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { SelectCurrencyUnit } from '../../../common/selectCurrencyUnit'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { selectAllowSetDefaultUnit } from '../../../common/selectCurrencyUnit/slice'
import EventEmitter, {
  CHANGE_COMPANY_HEADER,
} from '../../../helpers/EventEmitter'
import { Layout } from '../../Layout'
import { CompanyInfo } from '../../common/header/companyInfo'
import { Filter } from '../../common/header/filterBar'
import { ConfigTableData } from './ConfigTableData'
import { Notifications } from './Notifications'
import { RequestContact } from './common/RequestContact'
import { TYPE_OF_FS } from './constant'
import './lang/i18n'
import {
  changeSavedOrgId,
  resetStoreCompanyFinancialStatement,
  selectAuditStatuses,
  selectDataYears,
  selectMethods,
  selectSavedOrgId,
  selectSource,
  selectTypeOfFS,
} from './store/slice'
import { financialStatementsTable, legalRegulations } from './store/thunk'

export const FinancialStatements = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const organizationIdParams = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  }).organizationId

  const locale = useSelector((state) => state.i18n.locale)
  const allowSetDefaultUnit = useSelector(
    selectAllowSetDefaultUnit(SCREEN.FINANCIAL_STATEMENT),
  )
  const source = useSelector(selectSource)
  const typeOfFS = useSelector(selectTypeOfFS)
  const auditStatuses = useSelector(selectAuditStatuses)
  const methods = useSelector(selectMethods)
  const savedOrgId = useSelector(selectSavedOrgId)
  const dataYears = useSelector(selectDataYears)

  useEffect(() => {
    dispatch(legalRegulations())
  }, [])

  useEffect(() => {
    EventEmitter.subscribe(CHANGE_COMPANY_HEADER, () =>
      dispatch(resetStoreCompanyFinancialStatement()),
    )
  }, [])

  useEffect(() => {
    if (savedOrgId !== organizationIdParams) {
      dispatch(
        financialStatementsTable({
          organizationId: organizationIdParams,
        }),
      )
      dispatch(changeSavedOrgId(organizationIdParams))
      return
    }
    dispatch(
      financialStatementsTable({
        organizationId: organizationIdParams,
        sourceOrganizationId: source?.value,
        isConsolidated: typeOfFS?.value === TYPE_OF_FS.consolidated.value,
        years: dataYears?.length ? dataYears : undefined,
        auditStatuses,
        methods,
      }),
    )
  }, [locale])

  const renderTopComponent = () => {
    return (
      <>
        <CompanyInfo />
      </>
    )
  }

  const renderBottomComponent = () => {
    return (
      <div
        className="flexColumn h100"
        style={{ marginLeft: 6, marginRight: 6 }}
      >
        <Notifications />
        <ConfigTableData />
      </div>
    )
  }

  const renderStickyComponent = () => {
    return (
      <Filter
        renderLeft={() => <RequestContact />}
        renderRight={() => (
          <SelectCurrencyUnit screen={SCREEN.FINANCIAL_STATEMENT} />
        )}
      />
    )
  }

  return (
    <Layout
      renderTopComponent={renderTopComponent}
      renderBottomComponent={renderBottomComponent}
      renderStickyComponent={renderStickyComponent}
      isLoadingContent={allowSetDefaultUnit}
      isShowFooter={false}
    />
  )
}

export default FinancialStatements
